export const extractUrls = (subject: string): string[] => {
  // Regex to match URLs, but exclude email addresses
  const regexp =
    // eslint-disable-next-line regexp/no-unused-capturing-group
    /@?(https?:\/\/|www\.)?[a-z0-9.-]+\.[a-z]{2,63}(\b[-\w()@:%+.~#?&/=]*)?/giu;

  // Regex to clean unnecessary brackets or trailing characters
  const cleanupRegexp = /^[()[\]]+|[().[\]]+$/gu;

  // Match URLs using regex
  const urls = subject.match(regexp);

  return (
    urls?.map((item) =>
      item
        .toLowerCase()
        // Remove surrounding brackets/trailing dot
        .replaceAll(cleanupRegexp, ''),
    ) ?? []
  ).filter((item) => !item.includes('@'));
};
